export const APP_ROUTES = {
    appointments: 'https://citas.conextcrm.es',
    food_orders: 'https://pedidos.conextcrm.es',
    driving_school: 'https://autoescuela.conextcrm.es',
    marketing: 'https://marketing.conextcrm.es',
    ventas: 'https://ventas.verticetrade.es',
};
// Academias sobre la app de autoescuelas (3/11/2026, academia de Eva): la MISMA app servida en academia.conextcrm.es
// (alias de la distribución de CloudFront de autoescuela), para que no vean «autoescuela» en la barra de direcciones.
// El modo academia lo enciende su config (c_autoescuela_config.modo_academia), no el dominio.
const ACADEMIA_URL = 'https://academia.conextcrm.es';
const ACADEMIA_COMPANY_IDS = new Set(['academia-de-eva-7cd4e3']);
export const getAppUrl = (appType) => {
    return (appType && APP_ROUTES[appType]) || APP_ROUTES['appointments'];
};
// Empresa interna ConextCRM cuyo personal (excepto el superadmin)
// trabaja en la app de ventas en lugar de la app por defecto.
const VENTAS_COMPANY_ID = 'conextcrm-e2f0b3';
const VENTAS_COMPANY_ADMIN_EMAIL = 'administrador@conextcrm.es';
/**
 * Resuelve la URL de la app destino a partir del payload del JWT.
 * Aplica overrides por empresa/usuario antes de caer en `getAppUrl(app_type)`.
 *
 * Regla actual:
 * - Cualquier usuario de `conextcrm-e2f0b3` que NO sea `administrador@conextcrm.es`
 *   se redirige a la app de ventas (`https://ventas.verticetrade.es`).
 *   El superadmin sigue el flujo normal (`app_type` de la empresa).
 */
export const getAppUrlForUser = (payload) => {
    if (payload && payload.company_id && ACADEMIA_COMPANY_IDS.has(String(payload.company_id))) {
        return ACADEMIA_URL;
    }
    if (payload && payload.company_id === VENTAS_COMPANY_ID) {
        const identifier = String(payload.email || payload.username || payload.user_id || '')
            .trim()
            .toLowerCase();
        if (identifier && identifier !== VENTAS_COMPANY_ADMIN_EMAIL) {
            return APP_ROUTES['ventas'];
        }
    }
    return getAppUrl(payload?.app_type);
};
